import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertComponent } from './components/alert/alert.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { DeviceViewComponent } from './components/device-view/device-view.component';
import { HelpMenuComponent } from './components/help-menu/help-menu.component';
import { ListModule } from './components/list/list.module';
import { MaterialModule } from '../material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectedNodesPanelComponent } from './components/selected-nodes-panel/selected-nodes-panel.component';
import { SliderModule } from './components/slider/slider.module';
import { UserProfilePinComponent } from './components/user-profile-pin/user-profile-pin.component';
import { PanelComponent } from './components/panel/panel.component';
import { ZendeskConfigModule } from '../zendesk-config.module';
import { ButtonsModule } from './components/buttons/buttons.module';
import { TreeModule } from './components/tree/tree.module';
import { CardsModule } from './components/cards/cards.module';
import { LocalFormsModule } from './components/local-forms/forms.module';
import { DirectivesModule } from './directives/directives.module';
import { ProgressIndictatorsModule } from './components/progress-indicators/progress-indicators.module';
import { PipesModule } from './pipes/pipes.module';
import { PillboxModule } from './components/pillbox/pillbox.module';
import { TabsModule } from './components/tabs/tabs.module';
import { ColumnModule } from './components/column/column.module';
import { SortComponent } from './components/sort/sort.component';
import { SwatchItemComponent } from './components/swatch-item/swatch-item.component';
import { IconModule } from './components/icon/icon.module';
import { NodeActionsModule } from './components/node-actions/node-actions.module';
import { ColorPickerInputComponent } from './components/color-picker-input/color-picker-input.component';
import { PopupComponent } from './features/components/popup/popup.component';
import { MarkdownModule } from 'ngx-markdown';
import { CategoryImageComponent } from './components/category-image/category-image.component';
import { DividerComponent } from './components/divider/divider.component';
import { NavigationModule } from './components/navigation/navigation.module';
import { InputGroupComponent } from './components/input-group/input-group.component';
import { SystemMessageComponent } from './components/system-message/system-message.component';
import { ProfileBadgeComponent } from './components/profile-badge/profile-badge/profile-badge.component';
import { MessageToggleComponent } from './components/message-toggle/message-toggle.component';
import { RouterModule } from '@angular/router';
import { HtmlComponent } from './html/html.component';
import { ImageViewComponent } from './components/image-view/image-view.component';
import { LocalesComponent } from './components/locales/locales.component';
import { VerifyCodeInputComponent } from './components/verify-code-input/verify-code-input.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { TeamInviteComponent } from './components/team-invite/team-invite.component';
import { TogglePasswordInputComponent } from './components/toggle-password-input/toggle-password-input.component';
import { UserProfileNotificationsComponent } from './components/user-profile-notifications/user-profile-notifications.component';
import { CalloutContentComponent } from './components/callout-content/callout-content.component';
import { TagModule } from './components/tag/tag.module';
import { TeamFeaturesModule } from './components/team-features/team-features.module';
import { TeamUserComponent } from './components/team-user/team-user.component';
import { FeedbackMenuComponent } from './components/feedback-menu/feedback-menu.component';
import { OfflineMessageComponent } from './components/offline-message/offline-message.component';
import { HeaderNotificationComponent } from './components/header-notification/header-notification.component';

@NgModule({
  imports: [
    RouterModule,
    ButtonsModule,
    CardsModule,
    ColorPickerModule,
    ColumnModule,
    CommonModule,
    DirectivesModule,
    IconModule,
    LocalFormsModule,
    ListModule,
    MaterialModule,
    NavigationModule,
    NodeActionsModule,
    PillboxModule,
    PipesModule,
    ProgressIndictatorsModule,
    ReactiveFormsModule,
    SliderModule,
    TabsModule,
    TagModule,
    TreeModule,
    ZendeskConfigModule,
    MarkdownModule.forChild(),
  ],
  declarations: [
    AlertComponent,
    ColorPickerComponent,
    DeviceViewComponent,
    HelpMenuComponent,
    SelectedNodesPanelComponent,
    UserProfilePinComponent,
    PanelComponent,
    SortComponent,
    SwatchItemComponent,
    ColorPickerInputComponent,
    PopupComponent,
    CategoryImageComponent,
    DividerComponent,
    InputGroupComponent,
    SystemMessageComponent,
    ProfileBadgeComponent,
    MessageToggleComponent,
    HtmlComponent,
    ImageViewComponent,
    LocalesComponent,
    VerifyCodeInputComponent,
    VerifyEmailComponent,
    TeamInviteComponent,
    TeamUserComponent,
    TogglePasswordInputComponent,
    UserProfileNotificationsComponent,
    CalloutContentComponent,
    FeedbackMenuComponent,
    OfflineMessageComponent,
    HeaderNotificationComponent,
  ],
  exports: [
    AlertComponent,
    ButtonsModule,
    CardsModule,
    ColorPickerComponent,
    ColumnModule,
    DeviceViewComponent,
    DirectivesModule,
    LocalFormsModule,
    HelpMenuComponent,
    IconModule,
    ListModule,
    NavigationModule,
    NodeActionsModule,
    PipesModule,
    PillboxModule,
    TeamFeaturesModule,
    ProgressIndictatorsModule,
    SelectedNodesPanelComponent,
    SliderModule,
    TabsModule,
    TagModule,
    TreeModule,
    UserProfilePinComponent,
    PanelComponent,
    SortComponent,
    SwatchItemComponent,
    ColorPickerInputComponent,
    PopupComponent,
    CategoryImageComponent,
    DividerComponent,
    InputGroupComponent,
    SystemMessageComponent,
    ProfileBadgeComponent,
    MessageToggleComponent,
    HtmlComponent,
    ImageViewComponent,
    LocalesComponent,
    VerifyCodeInputComponent,
    VerifyEmailComponent,
    TeamInviteComponent,
    TeamUserComponent,
    TogglePasswordInputComponent,
    UserProfileNotificationsComponent,
    CalloutContentComponent,
    FeedbackMenuComponent,
    OfflineMessageComponent,
    HeaderNotificationComponent,
  ],
  entryComponents: [],
})
export class SharedModule {}
